import TreeSelect from 'ant-design-vue/es/tree-select'
export default {
  name: 'TreeSelect',
  props: ['value', 'select'],
  methods: {
    renderTree(treeData, bl) {
      return treeData.map(item => {
        return (
          <TreeSelect.TreeNode key={item.id} value={item.id} title={item.name}>
            {item.children.length ? this.renderTree(item.children) : ''}
          </TreeSelect.TreeNode>
        )
      })
    },
    change(val) {
      this.$emit('update:select', val)
    }
  },
  render() {
    return (
      <TreeSelect
        allow-clear
        onchange={this.change}
        defaultValue={0}
        treeDefaultExpandedKeys={[-1]}
        style={{ width: '100%' }}
        value={this.select}
      >
        <TreeSelect.TreeNode key={-1} value={0} title={'分类'}>
          {this.renderTree(this.value ? this.value : [])}
        </TreeSelect.TreeNode>
      </TreeSelect>
    )
  }
}
